<template>
  <sui-card>
    <sui-card-content>
      <sui-card-header>{{header}}</sui-card-header>
      <a v-bind:href="link">{{link}}</a>
      <sui-card-description>
        {{description}}
      </sui-card-description>
    </sui-card-content>
    <sui-card-content extra>
      <sui-icon name="info circle icon" />{{pricing}}
    </sui-card-content>
  </sui-card>
</template>

<script>
export default {
  name: 'basic-info',
  props: ['header', 'link', 'description', 'pricing']
}
</script>
